// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__kGMBF","img":"Banner_img__bq+3b","note":"Banner_note__mUQ8e","text-right-to-left":"Banner_text-right-to-left__JAtvC"};